import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const Response = z.object({
    authorized: z.boolean(),
});
export const url = ({ type: resourceType, id: resourceId, action, }) => {
    // We accept null for "resource level" permission questions
    const normalizedId = resourceId === null ? "*" : resourceId;
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/authz/v1/check/resource/${resourceType}/${normalizedId}/action/${action}`
        : `https://middleware.uat.farther.com/authz/v1/check/resource/${resourceType}/${normalizedId}/action/${action}`;
};
export default async function getAuthzCheck(check, config) {
    const res = await axios.get(url(check), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "Could not decode authz check response";
        errorLog("getAuthzCheck", `${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAuthzCheck.js.map